import { LinearProgress, NavigationTheme, Tab, Typography } from '@dls/react-core';
import React from 'react';
import { AppBar } from '@dls/react-core';
import StudiesPanelContents from './studies-panel-contents';
import { getStudies, Study } from '../../api/studykit';
import { Outlet, useMatch, useNavigate, useOutletContext } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { PageWrapper, StyledTabs } from '../../components/styled/styles';
import useRequest from '../../api/useRequest';

const STUDY_STATUSES = ['ongoing', 'completed'];

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const StudiesOverviewPanel = () => {
  const { studies, status } = useOutletContext<{ studies: Study[]; status: string }>();

  return (
    <StudiesPanelContents
      studies={studies.filter((e) => (e.status ? e.status === status : 'ongoing'))}
      status={status}
      title={capitalize(status) + ' studies'}
    />
  );
};

export const StudiesOverview = () => {
  const match = useMatch(RoutePaths.Studies + '/:status');
  const navigate = useNavigate();
  const status = match?.params.status;

  const { error, data: studies } = useRequest(getStudies());

  const studiesWithStatus = studies?.map((e) => ({
    ...e,
    status: new Date(e.end).valueOf() - new Date().valueOf() > 0 ? 'ongoing' : 'completed',
  }));

  return (
    <>
      <NavigationTheme>
        <AppBar position="static" color="secondary">
          <StyledTabs value={status}>
            {STUDY_STATUSES.map((s, i) => (
              <Tab
                data-testid={s}
                style={{ width: `8rem` }}
                key={STUDY_STATUSES[i]}
                value={s}
                label={capitalize(s)}
                className="navigation"
                onClick={() => navigate(s)}
              />
            ))}
          </StyledTabs>
        </AppBar>
      </NavigationTheme>
      <PageWrapper>
        {error ? (
          <Typography variant={'h1'}>Something went wrong...</Typography>
        ) : studies === undefined ? (
          <LinearProgress variant={'indeterminate'} />
        ) : (
          <Outlet context={{ studies: studiesWithStatus, status }} />
        )}
      </PageWrapper>
    </>
  );
};
